import { Component, OnInit, SimpleChanges, ViewChild, ElementRef } from '@angular/core';
import { AgentService } from './../services/agent.service';
import { ActivatedRoute, Router } from '@angular/router';
import { StepItem } from 'src/app/models/common/step-item';
import { SettingService } from 'src/app/system-common/services/setting.service';
import { Location } from '@angular/common';
import { PageHeader } from 'src/app/models/common/page-header';
import { BaseStepFormComponent } from 'src/app/system-common/base-step-form/base-step-form.component';
import { HeaderService } from 'src/app/system-common/services/header.service';
import { TabItem } from 'src/app/models/common/tab-items';
declare const showSpinner: any;
declare const hideSpinner: any;

@Component({
  selector: 'sym-agent-transfer-to-applicant',
  templateUrl: './agent-transfer-to-applicant.component.html',
  styleUrls: ['./agent-transfer-to-applicant.component.scss'],
})
export class AgentTransferToApplicantComponent extends BaseStepFormComponent<AgentService> implements OnInit {
  constructor(
    service: AgentService,
    route: ActivatedRoute,
    router: Router,
    location: Location,
    settingService: SettingService,
    headerService: HeaderService
  ) {
    super(service, route, router, location, settingService, headerService);
    // this.isTriggerOtpBtn = false;
  }
  // @ViewChild('remark') remark: ElementRef;
  // @ViewChild('saveCheckBoxValue') saveCheckBoxValue: ElementRef;
  // contentEditable: boolean;age
  isTriggerOtpBtn: boolean;
  // rejectRemark: any;
  message: { isSuccess: boolean; text: string };
  // forFocus: boolean;
  // forClose: boolean;
  // continueClick: boolean = false;

  ngOnInit() {
    super.ngOnInit();
    // if (
    //   this.service.responseIO != undefined &&
    //   this.service.responseIO.data.Entity.applicationStatusCd != 'REMOTE'
    // ) {
    //   // this.forClose = true;
    //   if (
    //     this.service.responseIO != undefined &&
    //     (this.service.responseIO.data.Entity.applicationStatusCd == 'SUBMITTED' ||
    //       this.service.responseIO.data.Entity.applicationStatusCd == 'RESUBMITTED')
    //   ) {
    //     this.message = {
    //       isSuccess: true,
    //       text: this.service.getMultilingualLabel('applicationDataSubmitted'),
    //     };
    //   } else if (
    //     this.service.responseIO != undefined &&
    //     this.service.responseIO.data.Entity.applicationStatusCd == 'REMOTEREJECTED'
    //   ) {
    //     this.message = {
    //       isSuccess: true,
    //       text: 'Application data is rejected!',
    //     };
    //   }else if(his.service.responseIO != undefined &&
    //     this.service.responseIO.data.Entity.applicationStatusCd == 'PENDING') {
    //     this.message = {
    //       isSuccess: true,
    //       text: 'Data is Transferred Back!',
    //     };
    //   } else {
    //     this.message = {
    //       isSuccess: true,
    //       text: 'Data is revoked!',
    //     };
    //   }
    //   this.openModal(`submitAgentModal`);
    // } else {
    //   // this.contentEditable = false;
    // }

    // setTimeout(() => {
    //   this.setStepStatusManual();
    // }, 2000);
  }

  protected getStepList(): StepItem[] {
    let stepList: StepItem[] = [
      new StepItem(
        0,
        'step_register',
        [
          {
            id: 'tab_basic',
            modelList: [
              'AgentParty',
              'AgentDetail',
              'RelativesList',
              'PaymentList',
              'EducationList',
              'TrainingList',
              'ExamList',
              'DocumentCategoryList',
              'DocumentList',
              'DocumentImageList',
              'PartyOccupation',
              'NotesModel',
              'ServiceSignatureList',
            ],
          },
        ],
        ['but_DraftSave', 'but_Continue']
      ),
      new StepItem(
        1,
        'step_completeDataEntry',
        [
          { id: 'tab_education', modelList: ['AgentParty', 'EducationList'] },
          { id: 'tab_training', modelList: ['TrainingList'] },
          { id: 'tab_bankdetails', modelList: ['PaymentList', 'AgentParty'] },
          { id: 'tab_exam', modelList: ['ExamList'] },
        ],
        ['but_Back', 'but_DraftSave', 'but_Continue']
      ),
      new StepItem(
        2,
        'step_requirement',
        [
          {
            id: 'tab_requirement',
            modelList: ['DocumentCategoryList', 'DocumentList', 'DocumentImageList'],
          },
        ],
        ['but_Back', 'but_DraftSave', 'but_Continue']
      ),
      new StepItem(
        3,
        'step_signature',
        [
          {
            id: 'tab_signature',
            modelList: ['ServiceSignatureList'],
          },
        ],
        ['but_Back', 'but_DraftSave', 'but_Continue']
      ),
      // new StepItem(
      //   4,
      //   'step_payment',
      //   [
      //     {
      //       id: 'tab_payment',
      //       modelList: ['AgentParty', 'AgentDetail'],
      //     },
      //   ],
      //   ['but_Back', 'but_Continue']
      // ),
      new StepItem(
        5,
        'step_reviewApp',
        [
          {
            id: 'tab_reviewApp',
            modelList: [
              'AgentParty',
              'AgentDetail',
              'RelativesList',
              'PaymentList',
              'EducationList',
              'TrainingList',
              'ExamList',
              'DocumentCategoryList',
              'DocumentList',
              'DocumentImageList',
              'PartyOccupation',
              'NotesModel',
              'ServiceSignatureList',
            ],
          },
        ],
        ['but_Back']
      ),
    ];
    return stepList;
  }

  // toggleEditable(value: boolean) {
  //   this.contentEditable = value;
  //   console.log('new', this.contentEditable);
  // }

  // protected but_Continue_click() {
  //   this.forFocus = false;
  //   if (this.selectedStep.id === 'step_reviewApp' && this.contentEditable == true) {
  //     if (
  //       this.selectedStep.id === 'step_reviewApp' &&
  //       (this.service.responseIO.data.Entity.applicationStatusCd === 'PENDING' ||
  //         this.service.responseIO.data.Entity.applicationStatusCd === 'REQUIREMENT' ||
  //         this.service.responseIO.data.Entity.applicationStatusCd === 'REMOTE' ||
  //         this.service.responseIO.data.Entity.applicationStatusCd === null)
  //     ) {
  //       this.continueClick = true;
  //       this.isTriggerOtpBtn = true;
  //     } else {
  //       super.but_Continue_click();
  //     }
  //   } else {
  //     this.continueClick = false;
  //     this.message = {
  //       isSuccess: true,
  //       text: 'Please accept terms & condition!',
  //     };
  //     this.openModal(`submitAgentModal`);
  //     super.but_DraftSave_click();
  //   }
  // }

  // protected but_Back_click(): void {
  //   super.but_Back_click();
  //   if (this.selectedStep != undefined && this.selectedStep.id == 'step_payment') {
  //     this.stepList[0]['buttonList'] = ['but_Continue', 'but_reject'];
  //   }
  // }

  // but_reject_click() {
  //   this.forFocus = true;
  //   this.continueClick = false;
  //   if (!(this.remark && this.remark.nativeElement && !this.remark.nativeElement.value.trim())) {
  //     this.rejectRemark = this.remark.nativeElement.value.trim();
  //     this.service.responseIO.data.Entity.applicationStatusCd = 'REMOTEREJECTED';
  //     this.service.responseIO.data.AgentDetail.remarks = this.rejectRemark;
  //     this.saveUpdatedModels(this.selectedStep, this.selectedStep, undefined, 'but_Submit');
  //   } else {
  //     this.message = {
  //       isSuccess: true,
  //       text: 'Please enter reject remark!',
  //     };
  //     this.openModal(`submitAgentModal`);
  //     super.but_DraftSave_click();
  //   }
  // }

  // public onValidateOtp(isValidOtp: boolean) {
  //   this.isTriggerOtpBtn = false;
  //   if (isValidOtp && this.selectedStep.id === 'step_reviewApp') {
  //     // let nextStepObj = this.stepList[this.selectedStep.index + 1];
  //     this.stepList[0]['buttonList'] = [];
  //     setTimeout(() => {
  //       showSpinner();
  //     }, 5);
  //     // this.service.responseIO.data.Entity.applicationStatusCd = 'PENDINGPAYMENT';
  //     this.saveUpdatedModels(this.selectedStep, this.selectedStep, undefined, 'but_Submit');
  //   }
  // }

  // protected onSaveUpdatedModels(
  //   body: any,
  //   currentStepObj: StepItem,
  //   nextStepObj?: StepItem,
  //   nextTabObj?: TabItem,
  //   buttonId?: string
  // ) {
  //   super.onSaveUpdatedModels(body, currentStepObj, nextStepObj, nextTabObj, buttonId);
  //   if (this.selectedStep.id == 'step_reviewApp' && buttonId == 'but_Submit') {
  //     this.service.responseIO.data.Entity.stepActionTabs = undefined;
  //     this.service.submitAgent().subscribe(
  //       (successResponse) => {
  //         this.service.responseIO = JSON.parse(JSON.stringify(successResponse));
  //         if (successResponse['success'] == true) {
  //           if (this.selectedStep.id == 'step_reviewApp' && this.continueClick) {
  //             this.message = {
  //               isSuccess: successResponse['success'],
  //               text: 'Agent Data has been submitted successfully !',
  //             };
  //             this.openModal(`submitAgentModal`);
  //             setTimeout(() => {
  //               if (this.selectedStep != null && this.selectedStep != undefined) {
  //                 hideSpinner();
  //               }
  //             }, 5);
  //             console.log('submit api response ' + successResponse);
  //             console.log('Agent submit successful.');
  //           } else if (this.forFocus) {
  //             setTimeout(() => {
  //               this.router.navigate(['agent-reject-view/' + this.id]);
  //             }, 1000);
  //           }
  //         } else {
  //           console.log('submit failed');
  //         }
  //       },
  //       (error) => {
  //         console.log('Agent submit failed.');
  //         console.log('Error:', error);
  //       }
  //     );
  //   }
  // }

  // closeSubmitAgentModal() {
  //   this.closeModal(`submitAgentModal`);
  // }

  protected getPageHeader(): PageHeader {
    let header = new PageHeader();

    return header;
  }

  protected preStepSelection(nextStepObj: StepItem): void {
    if (this.service.responseIO.data.Entity.isCompleted || this.service.responseIO.data.Entity.isInvalid) {
      nextStepObj.buttonList = [];
    }
  }

  // public setStepStatusManual() {
  //   this.stepList.forEach((stepItem: StepItem) => {
  //     if (this.selectedStep != undefined && this.selectedStep.index == stepItem.index) {
  //       stepItem.status = 'active';
  //     } else {
  //       //if the step in db is equal to all the possible steps lenght then the
  //       //workflow is complete
  //       if (
  //         this.service.responseIO != undefined &&
  //         this.service.responseIO.data.Entity.step >= this.stepList.length
  //       ) {
  //         stepItem.status = 'pending';
  //       } else {
  //         this.setCustomStepStatus(stepItem);
  //       }
  //     }
  //   });
  // }
}
